import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import { NavLink } from 'react-router-dom'
import NavLink from '../components/LinkHack'
import ReviewsReviewUser from './ReviewsReviewUser'
import WishlistButton from './WishlistButton'
import shortid from 'shortid'
import object_value from '../api/object_value'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react/index'
import prepare_rating from '../api/prepare_rating'
import { user_by_id } from '../api'
import moment from 'moment/moment'

@inject('userById')
@observer
class ReviewsReview extends Component {
  constructor (props) {
    super(props)

    this.state = {
      author_user: {
        data: {},
        loaded: false
      }
    }
  }

  componentDidMount() {
    const { review } = this.props
    console.log('ReviewsReview.js - componentDidMount() - review', review)

    user_by_id(review.user_id).then(data => {
      console.log('user_by_id', data)
      this.setState({
        author_user: {
          ...this.state.author_user,
          data,
          loaded: true
        }
      })
    })
  }

  render () {
    const { review } = this.props

    if (!review) {
      return (<div />)
    }

    return (
      <div className='b-reviews-review'>
        <div className='b-reviews-review-header'>
          <ReviewsReviewUser user={this.state.author_user} />
          <div className='b-reviews-review-header-date'>
            {moment(review.created_at).utc()/*.tz('Europe/Berlin')*/.format('DD.MM.YYYY')}
          </div>
        </div>
        <p>{review.text}</p>
      </div>
    )
  }
}

const numberOrString = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number
])

ReviewsReview.propTypes = {
  userById: MobxPropTypes.observableObject,
  review: PropTypes.shape({
    id: PropTypes.number,
    text: PropTypes.string,
    user_id: numberOrString,
    created_at: PropTypes.string
  }).isRequired
}

export default ReviewsReview


// WEBPACK FOOTER //
// ./src/components/ReviewsReview.js